// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3b4FF","label":"Section_label__25OPh","contentWrap":"Section_contentWrap__v8Wrz","footer":"Section_footer__19RdP","footerInner":"Section_footerInner__2F53t"};